import React, { useState } from 'react';
import { usePortfolioContext } from '../contexts/PortfolioContext';
import PortfolioManagementModal from './PortfolioManagementModal';

const PortfolioRequired = ({ title, description }) => {
  const { portfolios, loading, portfoliosLoaded } = usePortfolioContext();
  const [showPortfolioManager, setShowPortfolioManager] = useState(false);

  const isLoadingPortfolios = loading || !portfoliosLoaded;
  const noPortfolios = portfoliosLoaded && (portfolios || []).length === 0;

  return (
    <div className="flex justify-center items-center h-64">
      <div className="text-center">
        <h2 className="text-xl font-semibold mb-4">{title || 'Portfolio Required'}</h2>
        {isLoadingPortfolios ? (
          <div className="text-gray-600 dark:text-gray-400">
            <div className="mx-auto mb-3 h-8 w-8 animate-spin rounded-full border-2 border-blue-500 border-t-transparent" />
            <p>Loading your portfolios...</p>
          </div>
        ) : noPortfolios ? (
          <p className="text-gray-600 dark:text-gray-400">
            {description || "You don't have any portfolios yet."}{' '}
            <button
              onClick={() => setShowPortfolioManager(true)}
              className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 underline decoration-dotted underline-offset-2"
            >
              Create your first portfolio
            </button>
            {' '}to get started.
          </p>
        ) : (
          <p className="text-gray-600 dark:text-gray-400">
            {description || 'Please select a portfolio to continue.'}
          </p>
        )}
        {showPortfolioManager && (
          <PortfolioManagementModal
            isOpen={showPortfolioManager}
            onClose={() => setShowPortfolioManager(false)}
            defaultCreateOpen
          />
        )}
      </div>
    </div>
  );
};

export default PortfolioRequired;


